var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5L8.09375 10.7273L8.09544 10.7288C7.40997 11.6001 7 12.7059 7 13.9091C7 16.7207 9.23858 19 12 19C14.7614 19 17 16.7207 17 13.9091C17 12.7059 16.59 11.6001 15.9046 10.7288L15.9062 10.7273L12 5ZM13.25 17.7273C14.6307 17.7273 15.75 16.5876 15.75 15.1818C15.75 13.776 14.6307 12.6364 13.25 12.6364C11.8693 12.6364 10.75 13.776 10.75 15.1818C10.75 16.5876 11.8693 17.7273 13.25 17.7273Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37256 0 0 5.37258 0 12C0 18.6274 5.37256 24 12 24ZM12 22C17.5228 22 22 17.5229 22 12C22 6.47715 17.5228 2 12 2C6.47717 2 2 6.47715 2 12C2 17.5229 6.47717 22 12 22Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.acf1945ed64c9aa355fc5e71e86871f5.svg";
export { ForwardRef as ReactComponent };